const HotelData = [
  { text: "Taj", value: 1 },
  { text: "Al Taj Hotel", value: 2 },
  { text: "Le Meridean", value: 3 },
  { text: "Sun Group ", value: 4 },
  { text: "Royal", value: 5 },
  { text: "Hotel Merina", value: 6 },
];


export {HotelData}